module.exports = {
    dpresults: {
        to: 'dpresults_accommodation',
    },
    roomselection: {
        to: 'dpresults_accommodation_details',
    },
    booking: {
        to: 'details',
        params: ';redirect=dpresults',
    },
    passengersinfo: {
        to: 'details',
    },
};
